/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./slotMachine.vue?vue&type=template&id=2558028a&scoped=true"
import script from "./slotMachine.vue?vue&type=script&lang=js"
export * from "./slotMachine.vue?vue&type=script&lang=js"
import style0 from "./slotMachine.vue?vue&type=style&index=0&id=2558028a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2558028a",
  null
  
)

export default component.exports